import ZagUpgradePrompt from './ZagUpgradePrompt';
import UpgradeConfirmationBanner from './UpgradeConfirmationBanner';
import { useProduct } from 'contexts/ProductPageContext';

const ZagUpgradeWrapper = () => {
  const { isLayer } = useProduct();

  return !isLayer ? <ZagUpgradePrompt /> : <UpgradeConfirmationBanner />;
};

export default ZagUpgradeWrapper;
